import DetailsContainer from "../../components/DetailsContainer";
import General from "./General";
import OtherInfo from "./OtherInfo";

const Details = () => {
    return (
        <DetailsContainer>
            <General />
            <OtherInfo />
        </DetailsContainer>
    );
};

export default Details;
